import DashboardTypeEnum from "@/enums/DashboardTypeEnum";

/** Modèle de widget (utilisé pour la bibliothèque de widgets du MainDashboard et ObjectDashboard) */
class WidgetLibrary {
	/** Nom du widget */
	Name: string;
	/** Libellé du widget */
	Label: string;
	/** Description du widget */
	Description: string;
	/** Indique les types de tableaux de bord sur lesquels le widget peut être ajouté */
	TargetDashboards: DashboardTypeEnum[];
	/** Indique les types d'objet ciblés par le type de widget */
	TargetObjectTypes: string[];
	/** Nom de l'icone à afficher dans la bibliothèque de widget (liste complète des icones affichables sur https://fontawesome.com/search?m=free&o=r) */
	Icon: string;
	/** Indique si le widget doit apparaître désactivé et est donc non ajoutable sur un tableau de bord */
	Disabled: boolean;
	/** Indique si le widget utilise le sélecteur de mode (Simple ou Avancé) ou non */
	HasModeSelector: boolean;
	/** 
	 * Indique si le VueGridItem contenant le widget se redimenssionne automatique en fonction du contenu du widget ou non
	 * @description Si False, le widget s'adapte automatiquement à la taille du Vue-Grid-Item/WidgetContainer (son parent)
	 */
	AutoSize: boolean;
	/** Largeur minimale du widget (en nombre de colonnes) */
	MinW: number;
	/** 
	 * Indique s'il est possible d'exporter le widget ou non
	 * @description Génère un DataSet dans le contrôleur pour s'interfacer avec le composant Vue ExportWork (côté client)
	 */
	WithExport: boolean;
	/** 
	 * Indique la liste des fonctions exportables
	 * @description Génère un DataSet dans le contrôleur pour s'interfacer avec le composant Vue ExportWork (côté client)
	 */
	ExportableFeatures: string[];
	/** Indique les fonctions Analysis intégrables dans le widget */
	TargetFeatures: string[];

	/** Indique les type de recherche d'objet en mode simple */
	NodeSearchTypes: string[];
}

export default WidgetLibrary;